import { SpeechBubble } from '@/components/alisa/SpeechBubble';
import { ALISA_IMAGES } from '@/data/moduleData';
import { useT } from '@/i18n';
import { motion } from 'framer-motion';

export const InfoScene = ({ scene, onContinue }) => {
  const t = useT();

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="flex flex-col flex-1"
    >
      {/* Scene image and Alisa Character Overlay */}
      <div className="relative w-full aspect-[16/9] overflow-hidden bg-muted">
        {scene.image && (
          <img
            src={scene.image}
            alt={scene.title}
            className="w-full h-full object-cover"
          />
        )}

        {/* Overlaid Alisa Character */}
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          animate={{ opacity: 1, x: 0 }}
          className="absolute left-0 bottom-0 h-[100%] z-10 pointer-events-none"
        >
          <img
            src={ALISA_IMAGES.neutral}
            alt={t('ui.alisa.name')}
            className="h-full w-auto object-contain object-bottom"
          />
        </motion.div>

        {/* Shadow Overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-black/20 to-transparent pointer-events-none" />
      </div>

      {/* Content */}
      <div className="flex-1 px-4 py-4 flex flex-col">
        <SpeechBubble
          text={scene.alisa_text}
          emotion={scene.alisa_emotion}
          className="mb-auto"
        />
      </div>

      {/* Continue button */}
      <div className="px-4 pb-4">
        <motion.button
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5 }}
          onClick={onContinue}
          className="w-full gradient-primary-btn text-primary-foreground font-heading font-bold text-base py-3.5 rounded-xl shadow-primary hover:shadow-primary-hover active:scale-[0.98] transition-transform duration-150 uppercase tracking-wide"
        >
          {scene.is_final ? t('ui.common.seeResults') : t('ui.common.continue')}
        </motion.button>
      </div>
    </motion.div>
  );
};
